import toast from "react-hot-toast";
import { Button, Input } from "../../../ui";
import RadioButton from "../../../ui/RadioButton";
import AsyncSelectControlled from "../../../inputs/AsyncSelectControlled";
import Checkbox from "../../../ui/Checkbox";

const calculationTypeRadios = [
  { label: "Fixed Pay", value: "FIXED" },
  { label: "Variable Pay", value: "VARIABLE" },
];

const epfTypeRadios = [
  { label: "Always", value: "ALWAYS" },
  { label: "Only when PF wage is less than ₹ 15,000", value: "LESS_THAN" },
];

const AddEditSalaryComponentForm = ({
  isEdit,
  control,
  watch,
  handleSubmit,
  setValue,
  addComponent,
  editComponent,
  isAdding,
  isEditing,
  derivedOptions,
  hasMore,
  fetchNextDerivedOptions,
}) => {
  const onError = (errors) => {
    console.log("errors", errors);
    toast.error("Please enter all required fields");
  };

  const fromCtc = watch("from_ctc");
  const calculationType = watch("calculation_type");

  const onCalculationTypeChange = () => {
    setValue("value", 0);
  };

  return (
    <form
      className="grid grid-cols-2 gap-5"
      onSubmit={handleSubmit(isEdit ? editComponent : addComponent, onError)}
    >
      <div>
        <label htmlFor="" className="font-medium">
          Component Name
          <span className="text-red-500">*</span>
        </label>
        <Input
          type="text"
          control={control}
          name="name"
          rules={{ required: "Component name is required" }}
        />
      </div>

      <div>
        <label htmlFor="" className="font-medium">
          Name in payslip
          <span className="text-red-500">*</span>
        </label>
        <Input
          type="text"
          control={control}
          name="name_in_payslip"
          rules={{ required: "Name in payslip is required" }}
        />
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="" className="font-medium">
          Calculation type
          <span className="text-red-500">*</span>
        </label>
        {calculationTypeRadios.map((radio) => (
          <RadioButton
            key={radio.value}
            label={radio.label}
            value={radio.value}
            control={control}
            onChangeFn={onCalculationTypeChange}
            className={"w-fit"}
            name="calculation_type"
          />
        ))}
      </div>

      <div>
        {calculationType === "VARIABLE" && (
          <>
            <Checkbox
              control={control}
              name="from_ctc"
              className={"block mb-4 w-fit"}
              label="Derive amount from CTC?"
            />

            {!fromCtc && (
              <>
                <label htmlFor="" className="font-medium">
                  Derive from
                </label>
                <AsyncSelectControlled
                  control={control}
                  name="derived_from"
                  isMultiple={true}
                  options={derivedOptions}
                  hasMore={hasMore}
                  fetchNext={fetchNextDerivedOptions}
                />
              </>
            )}
          </>
        )}
      </div>

      <div className="py-5">
        <Checkbox
          control={control}
          name="pro_rata"
          className={"block mb-2 w-fit"}
          label="Is pro rata?"
        />
        <Checkbox
          control={control}
          name="consider_for_epf"
          className={"block mb-2 w-fit"}
          label="Consider for EPF?"
        />
        <Checkbox
          control={control}
          name="consider_for_esi"
          className={"block mb-2 w-fit"}
          label="Consider for ESI?"
        />
        <Checkbox
          control={control}
          name="show_in_payslip"
          className={"block w-fit"}
          label="Show in payslip?"
        />
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="" className="font-medium">
          EPF type
        </label>
        {epfTypeRadios.map((radio) => (
          <RadioButton
            key={radio.value}
            label={radio.label}
            value={radio.value}
            control={control}
            className={"w-fit"}
            name="epf_type"
          />
        ))}
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="" className="font-medium">
          Value
        </label>
        <div className="flex items-center w-full">
          {calculationType === "FIXED" && (
            <p className="mr-2 font-semibold">&#8377;</p>
          )}
          <Input
            type="number"
            parentClassName="grow"
            control={control}
            name="value"
            isPositiveNumber={true}
            min={0}
            max={calculationType === "VARIABLE" ? 100 : null}
            rules={{
              min: { value: 0, message: "Value cannot be lesser than 0" },
              max:
                calculationType === "VARIABLE"
                  ? { value: 100, message: "Value cannot be greater than 100" }
                  : undefined,
            }}
          />
          {calculationType === "VARIABLE" && (
            <p className="ml-2 font-semibold">%</p>
          )}
        </div>
      </div>

      <div className="flex justify-center col-span-2">
        <Button
          type="submit"
          disabled={isAdding || isEditing}
          className="hover:bg-primary/90 transition-colors"
        >
          {isEdit ? "Update Component" : "Add Component"}
        </Button>
      </div>
      {(isAdding || isEditing) && (
        <p className="text-center w-full col-span-2">Saving...</p>
      )}
    </form>
  );
};

export default AddEditSalaryComponentForm;
